import React, { useState } from 'react';
import { func, string } from 'prop-types';
import { Select } from '@thd-olt-component-react/select';
import * as analytics from '../../../ratings-reviews-analytics';

export const Sort = ({ onChange, sortBy }) => {

  if (typeof onChange !== 'function') {
    return null;
  }
  const sortOptions = [
    { name: 'Photo Reviews', value: 'photoreview' },
    { name: 'Most Helpful', value: 'mosthelpfull' },
    { name: 'Oldest', value: 'oldest' },
    { name: 'Newest', value: 'newest' },
    { name: 'Highest rating', value: 'highestrating' },
    { name: 'Lowest rating', value: 'lowestrating' }
  ];
  const [selected, setSelected] = useState(sortBy);

  const onSortChange = (e) => {
    let { value } = e.target;
    setSelected(value);
    analytics.track('event', {
      origin: 'ratings and reviews',
      location: 'sort',
      value,
      eventType: 'click'
    });
    onChange(value);
  };

  return (
    <div className="ratings-and-reviews__sort">
      <Select
        header="Sort By:"
        selected={selected}
        options={sortOptions}
        onChange={onSortChange}
      />
    </div>
  );

};

Sort.displayName = 'RatingsAndReviewsSort';

Sort.propTypes = {
  onChange: func.isRequired,
  sortBy: string.isRequired
};
